import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import Chart from 'chart.js/auto';
import { ApplicantStatusService } from "src/app/services/Applicant-Status.service";
import { AppointmentCountModel } from "src/app/model/AppointmentCountModel";
import { FormGroup } from '@angular/forms';
import { Page } from 'src/app/model/Page';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { ApplicantListModel } from 'src/app/services/ApplicantListModel';
import { ExcelExportService } from 'src/app/services/excel-export.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-secure-visitor-dashboard',
  templateUrl: './visitorDashboard.component.html',
  styleUrls: ['./visitorDashboard.component.scss'],
})
export class VisitorDashboardComponent implements OnInit {
  @ViewChild('myChart') myChart!: ElementRef;
  @ViewChild('dailyApprovedChart') dailyApprovedChart!: ElementRef;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  appointmentCountModel: AppointmentCountModel;
  pendingCount: number = 0;
  approvedCount: number = 0;
  rejectedCount: number = 0;
  forwardedCount: number = 0;
  rescheduledCount: number = 0;
  pendingCountToaday: number = 0;
  approvedCountToaday: number = 0;
  rejectedCountToaday: number = 0;
  forwardedCountToaday: number = 0;
  rescheduledCountToaday: number = 0;
  showTable: boolean = false;
  dailyApprovedData: number[] = [];
  chart: Chart | undefined;
  userName: string;
  totalCount: number = 0;
  listTitle: string = '';
  List: ApplicantListModel[] = [];
  showList: boolean = false;
  applicantList: ApplicantListModel[] = [];

  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  filterForm: FormGroup = new FormGroup({});
  page: Page<ApplicantListModel>;
  isSearchDisabled: boolean = false;
  selectedStatus: string = '';
  fromDate: string | null = null;
  toDate: string | null = null;
  dataSource: MatTableDataSource<ApplicantListModel> = new MatTableDataSource();

  constructor(private ApplicantStatusService: ApplicantStatusService, 
    private excelExportService: ExcelExportService,
    private router: Router,
    private route: ActivatedRoute


  ) {}

ngOnInit(): void {

  this.route.queryParams.subscribe(params => {

    if (params['status']) {
      this.selectedStatus = params['status'];
      this.showList = true;
      this.listTitle = this.selectedStatus;

      this.currentPage = 0;
      this.getList(this.selectedStatus);

    } else {
      this.showList = false;
      this.appointmentCOuntAndDetails();
      this.appointmentCOuntAndDetailsToaday();
      this.fetchDailyApprovedData();
    }

  });
}

  appointmentCOuntAndDetails() {
    this.userName = localStorage.getItem("userName");
    this.pendingCount = null;
    this.approvedCount = null;
    this.rejectedCount = null;
    this.forwardedCount = null;
    this.rescheduledCount = null;
    this.ApplicantStatusService.fetchappointmentPendingCount().subscribe(
      (data: any) => {
        console.log(data, "data");

        this.pendingCount = data.pendingCount;
        this.approvedCount = data.approvedCount;
        this.rejectedCount = data.rejectedCount;
        this.forwardedCount = data.forwardedCount;
        this.rescheduledCount = data.rescheduledCount;
        this.totalCount =
          this.pendingCount +
          this.approvedCount +
          this.rejectedCount +
          this.forwardedCount +
          this.rescheduledCount;

        this.createDailyApprovedChart();
      },
      (err: any) => {
        console.log(err, " error Method Called");
      }
    );
  }

  appointmentCOuntAndDetailsToaday() {
    this.userName = localStorage.getItem("userName");
    this.pendingCountToaday = null;
    this.approvedCountToaday = null;
    this.rejectedCountToaday = null;
    this.forwardedCountToaday = null;
    this.rescheduledCountToaday = null;
    this.ApplicantStatusService.fetchappointmentPendingCountToaday().subscribe(
      (data: any) => {
        console.log(data, "data");

        this.pendingCountToaday = data.pendingCountToaday;
        this.approvedCountToaday = data.approvedCountToaday;
        this.rejectedCountToaday = data.rejectedCountToaday;
        this.forwardedCountToaday = data.forwardedCountToaday;
        this.rescheduledCountToaday = data.rescheduledCountToaday;
        this.totalCount =
          this.pendingCount +
          this.approvedCount +
          this.rejectedCount +
          this.forwardedCount +
          this.rescheduledCount;

        this.createChart();
      },
      (err: any) => {
        console.log(err, " error Method Called");
      }
    );
  }
  // export() {
  //   const status = this.selectedStatus;
  //   const fromDate = this.fromDate;
  //   const toDate = this.toDate;
  
  //   this.ApplicantStatusService.getApplicantList(
  //     status,
  //     0, 
  //     10000, 
  //     fromDate,
  //     toDate
  //   ).subscribe(
  //     (page: Page<ApplicantListModel>) => {
  //       if (page.content) {
  //         let lst: {[key: string]: string}[] = [];
  
  //         for (let applicant of page.content) {
  //           lst.push({
  //             'BoardName': applicant.boardName,
  //             'OfficerName': applicant.officerName,
  //             'Applicant Name': applicant.applicantName,
  //             'Applicant mobile Number': applicant.mobileNumber,
  //             'Applicant EmailId': applicant.emailId,
  //             'Appointment Date': applicant.appointment_date,
  //             'Appointment Start time': applicant.appointmentStratTime,
  //             'Appointment End time': applicant.appointmentEndTime,
  //             'Appointment Status': applicant.appointmentStatus,
  //           });
  //         }
  
  //         this.excelExportService.exportExcel(
  //           "Appointment Detail",
  //           ["BoardName","OfficerName","Applicant Name","Applicant mobile Number","Applicant EmailId",  "Appointment Date", "Appointment Start time", "Appointment End time","Appointment Status" ],
  //           lst,
  //           "30,40,50,20,20,20,30",
  //           "User",
  //           new Date().toISOString()
  //         );
  //       }
  //     },
  //     (error) => {
  //       console.log(error);
  //     }
  //   );
  // }
 export() {
  const status = this.selectedStatus;
  const fromDate = this.fromDate;
  const toDate = this.toDate;

  this.ApplicantStatusService.getApplicantList(
    status,
    0,
    10000,
    fromDate,
    toDate
  ).subscribe(
    (page: Page<ApplicantListModel>) => {

      if (page.content && page.content.length > 0) {

        const boardWiseCount: any = {};
        const officerWiseCount: any = {};

        // Calculate Board-wise and Officer-wise counts
        page.content.forEach(applicant => {

          const board = applicant.boardName || 'NA';
          const officer = applicant.officerName || 'NA';
          const appointmentStatus = applicant.appointmentStatus;

          // Board Count Initialization
          if (!boardWiseCount[board]) {
            boardWiseCount[board] = {
              approved: 0,
              pending: 0,
              rejected: 0,
              rescheduled: 0,
              total: 0
            };
          }

          // Officer Count Initialization
          if (!officerWiseCount[officer]) {
            officerWiseCount[officer] = {
              approved: 0,
              pending: 0,
              rejected: 0,
              rescheduled: 0,
              total: 0
            };
          }

          switch (appointmentStatus) {

            case 'APPROVED':
              boardWiseCount[board].approved++;
              officerWiseCount[officer].approved++;
              boardWiseCount[board].total++;
              officerWiseCount[officer].total++;
              break;

            case 'PENDING':
              boardWiseCount[board].pending++;
              officerWiseCount[officer].pending++;
              boardWiseCount[board].total++;
              officerWiseCount[officer].total++;
              break;

            case 'REJECTED':
              boardWiseCount[board].rejected++;
              officerWiseCount[officer].rejected++;
              boardWiseCount[board].total++;
              officerWiseCount[officer].total++;
              break;

            case 'RESCHEDULED':
              boardWiseCount[board].rescheduled++;
              officerWiseCount[officer].rescheduled++;
              boardWiseCount[board].total++;
              officerWiseCount[officer].total++;
              break;
          }
        });

        // Board Summary
        const boardSummaryRows = Object.keys(boardWiseCount).map(board => ({
          board,
          approved: boardWiseCount[board].approved,
          pending: boardWiseCount[board].pending,
          rejected: boardWiseCount[board].rejected,
          rescheduled: boardWiseCount[board].rescheduled,
          total: boardWiseCount[board].total
        }));

        // Officer Summary
        const officerSummaryRows = Object.keys(officerWiseCount).map(officer => ({
          officer,
          approved: officerWiseCount[officer].approved,
          pending: officerWiseCount[officer].pending,
          rejected: officerWiseCount[officer].rejected,
          rescheduled: officerWiseCount[officer].rescheduled,
          total: officerWiseCount[officer].total
        }));

        let lst: { [key: string]: any }[] = [];

        const maxRows = Math.max(
          page.content.length,
          boardSummaryRows.length,
          officerSummaryRows.length
        );

        for (let i = 0; i < maxRows; i++) {

          const applicant = page.content[i];
          const boardSummary = boardSummaryRows[i];
          const officerSummary = officerSummaryRows[i];

          lst.push({

            // Appointment Details
            'BoardName': applicant?.boardName || '',
            'OfficerName': applicant?.officerName || '',
            'Applicant Name': applicant?.applicantName || '',
            'Applicant mobile Number': applicant?.mobileNumber || '',
            'Applicant EmailId': applicant?.emailId || '',
            'Appointment Date': applicant?.appointment_date || '',
            'Appointment Start time': applicant?.appointmentStratTime || '',
            'Appointment End time': applicant?.appointmentEndTime || '',
            'Appointment Status': applicant?.appointmentStatus || '',

            // Separator
            ' ': '',

            // Board Summary
            'Board Summary': boardSummary?.board || '',
            'B_APPROVED': boardSummary?.approved ?? '',
            'B_PENDING': boardSummary?.pending ?? '',
            'B_REJECTED': boardSummary?.rejected ?? '',
            'B_RESCHEDULED': boardSummary?.rescheduled ?? '',
            'B_TOTAL': boardSummary?.total ?? '',

            // Separator 2
            '  ': '',

            // Officer Summary
            'Officer Summary': officerSummary?.officer || '',
            'O_APPROVED': officerSummary?.approved ?? '',
            'O_PENDING': officerSummary?.pending ?? '',
            'O_REJECTED': officerSummary?.rejected ?? '',
            'O_RESCHEDULED': officerSummary?.rescheduled ?? '',
            'O_TOTAL': officerSummary?.total ?? ''
          });
        }

        this.excelExportService.exportExcel(
          "Appointment Detail",
          [
            "BoardName",
            "OfficerName",
            "Applicant Name",
            "Applicant mobile Number",
            "Applicant EmailId",
            "Appointment Date",
            "Appointment Start time",
            "Appointment End time",
            "Appointment Status",

            " ",

            "Board Summary",
            "B_APPROVED",
            "B_PENDING",
            "B_REJECTED",
            "B_RESCHEDULED",
            "B_TOTAL",

            "  ",

            "Officer Summary",
            "O_APPROVED",
            "O_PENDING",
            "O_REJECTED",
            "O_RESCHEDULED",
            "O_TOTAL"
          ],
          lst,
          "30,30,30,25,35,20,20,20,20,5,30,15,15,15,15,15,5,30,15,15,15,15,15",
          "User",
          new Date().toISOString()
        );
      }
    },
    (error) => {
      console.log(error);
    }
  );
}
  

  refresh(): void {
    console.log("Refreshing data and clearing date filters...");
  
    this.fromDate = null;
    this.toDate = null;
      this.currentPage = 0;
    if (this.paginator) {
      this.paginator.firstPage();
    }
      if (this.selectedStatus) {
      this.getList(this.selectedStatus);
    }
  }
  
  

  createChart() {
    const ctx = this.myChart.nativeElement.getContext("2d");
    const myChart = new Chart(ctx, {
      type: "bar",
      data: {
        labels: ["Pending", "Approved", "Rejected", "Forwarded", "Rescheduled"],
        datasets: [
          {
            label: "Today Appointment Count",
            data: [
              this.pendingCountToaday,
              this.approvedCountToaday,
              this.rejectedCountToaday,
              this.forwardedCountToaday,
              this.rescheduledCountToaday,
            ],
            backgroundColor: [
              "#f59e0b",
              "#4caf50",
              "#f44336",
              "#2196f3",
              "#ff9800",
            ],
            borderWidth: 1,
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 20,
            bottom: 20,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    });
  }

  fetchDailyApprovedData(): void {
    this.ApplicantStatusService.fetchMonthlyApprovedAppointments().subscribe(
      (data: any) => {
        console.log("Data received:", data);
        this.dailyApprovedData = data;
        this.createDailyApprovedChart();
      },
      (err: any) => {
        console.log(err, "error Method Called");
      }
    );
  }

  createDailyApprovedChart(): void {
    const ctx = this.dailyApprovedChart.nativeElement.getContext("2d");
    console.log(this.dailyApprovedData, "dailyApprovedData Method Called");

    const monthlyData = new Array(12).fill(0);

    Object.keys(this.dailyApprovedData).forEach((key) => {
      const monthIndex = parseInt(key, 10) - 1;
      const count = this.dailyApprovedData[key];
      console.log(`Mapping month ${key} to index ${monthIndex} with value ${count}`);
      if (monthIndex >= 0 && monthIndex < 12) {
        monthlyData[monthIndex] = count;
      }
    });

    console.log("Final monthlyData array:", monthlyData);

    if (this.chart) {
      this.chart.destroy();
    }

    this.chart = new Chart(ctx, {
      type: "line",
      data: {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ],
        datasets: [
          {
            label: "Monthly Approved Appointments",
            data: monthlyData,
            backgroundColor: "rgba(54, 162, 235, 0.2)",
            borderColor: "rgba(54, 162, 235, 1)",
            borderWidth: 1,
            fill: true,
          },
        ],
      },
      options: {
        scales: {
          y: {
            beginAtZero: true,
          },
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    });
  }

  showItems(status: string) {
  this.router.navigate(['/secure/visitor-dashboard'], {
    queryParams: { status: status }
  });
}

  displayedColumns: string[] = ['id', 'appointmentId', 'applicantName', 'appointment_date', 'appointment_time', 'mobileNumber', 'emailId', 'appointmentStatus'];
  applyDateFilter(): void {
    if (!this.fromDate || !this.toDate) {
      alert("Please select both From Date and To Date.");
      return;
    }
    this.getList(this.selectedStatus);
  }
  
  getList(status: string) {
    this.ApplicantStatusService.getApplicantList(
      status,
      this.currentPage,
      this.pageSize,
      this.fromDate,
      this.toDate
    ).subscribe(
      (page: Page<ApplicantListModel>) => {
        this.List = page.content;
        this.dataSource.data = this.List;
        this.totalRows = page.totalElements;
      },
      (error) => {
        console.log(error);
      }
    );
  }
  
  backToDashboard() {
    this.showList = false;
    this.appointmentCOuntAndDetails();
    this.appointmentCOuntAndDetailsToaday();
    this.fetchDailyApprovedData();
    let roles = localStorage.getItem("roles");
    this.userName = localStorage.getItem("userName");
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getList(this.listTitle); 
  }
}
